import type { MarketplaceFulfillmentStatus } from "@nexus/contracts";

/** Linked script is already sent for revision — disable ops “move to revision” again. */
export function isOpsMoveToRevisionDisabled(
  fulfillmentStatus: MarketplaceFulfillmentStatus,
): boolean {
  return fulfillmentStatus === "SENT_FOR_REVISION";
}
